import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Header from './Components/Layout/Header';
import Location from './Pages/Location';
import Simulate from './Pages/Simulate';

import { DrawerContextProvider } from './store/DrawerContext';
import { ModalContextProvider } from './store/ModalContext';
import { UserContextProvider } from './store/UserContext';
import DetailsModal from './Components/DetailsModal';
import DetailsDrawer from './Components/DetailsDrawer';
import Authorize from './Pages/Authorize';

function RedirectToMainSite() {
  useEffect(() => {
    window.location.href = 'https://delivait.com';
  }, []);
  return null;
}

function AppContent() {
  const location = useLocation();
  const isAuthorizePage = location.pathname.startsWith('/authorize');

  return (
    <>
      {!isAuthorizePage && <Header />}
      <main className="main">
        <Routes>
          <Route path="/:trackingId/:lat/:lng" exact index element={<Location/>} />
          <Route path="/simulate/:lat/:lng" exact index element={<Simulate/>} />
          <Route path="/authorize/:userId/contact/:phone" exact index element={<Authorize/>} />
          <Route path="/overview" exact element={<Location/>} />
          <Route path="/" exact index element={<RedirectToMainSite />} />
        </Routes>
      </main>
      <DetailsModal />
      <DetailsDrawer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <UserContextProvider>
        <DrawerContextProvider>
          <ModalContextProvider>
            <BrowserRouter>
              <AppContent />
            </BrowserRouter>
          </ModalContextProvider>
        </DrawerContextProvider>
      </UserContextProvider>
    </div>
  );
}

export default App;
